import {axios} from "~/plugins/axios"

const getDefaultState_Tariffications = () => {
  return {
    report: [],
  }
}
const state = getDefaultState_Tariffications()

const getters = {}

const actions = {
  async loadTargetAiStatistic({ commit }, payload) {
    commit('shared/SET_LOADING', true, {root: true})

    return await axios.post('/api/voice-assistants/get-results', payload)
      .then(response => {
        return response.data
      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true})
        commit('shared/SET_ERROR', error.response.data, {root: true})
      }).finally(() => {
        commit('shared/SET_LOADING', false, {root: true})
      })
  },

  async loadTargetAiTotalStat(context, payload) {
    return await axios.post('/api/voice-assistants/get-total_stat', payload)
      .then(response => {
        const data = response.data
        const row = Array.isArray(data) && data.length ? data[0] : null
        return { row, requestFailed: false }
      })
      .catch(() => {
        return { row: null, requestFailed: true }
      })
  },

  async loadTargetAiAgent({ commit }) {
    commit('shared/SET_LOADING', true, {root: true})

    return await axios.get('/api/target-ai/agents')
      .then(response => {
        return response.data
      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true})
        commit('shared/SET_ERROR', error.response.data, {root: true})
      }).finally(() => {
        commit('shared/SET_LOADING', false, {root: true})
      })

  },

  async loadAudio({ commit }, id) {
    commit('shared/SET_LOADING', true, {root: true})

    return await axios.get(`/api/voice-assistants/get-audio/${id}`,{
      responseType: 'blob',
    })
      .then(response => {
        return response.data
      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true})
        commit('shared/SET_ERROR', error.response.data, {root: true})
      }).finally(() => {
        commit('shared/SET_LOADING', false, {root: true})
      })
  },

  async loadTranscribe({ commit }, id) {
    commit('shared/SET_LOADING', true, {root: true})

    return await axios.get(`/api/voice-assistants/get-transcript/${id}`)
      .then(response => {
        return response.data
      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true})
        commit('shared/SET_ERROR', error.response.data, {root: true})
      }).finally(() => {
        commit('shared/SET_LOADING', false, {root: true})
      })
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
